export enum CreateRequestType {
  patient = 2,
  familyOrFriend = 3,
  concierge = 4,
  businessPartners = 1,
}
